import { render, staticRenderFns } from "./AnomalyDetection.vue?vue&type=template&id=61daf12e&"
import script from "./AnomalyDetection.vue?vue&type=script&lang=ts&"
export * from "./AnomalyDetection.vue?vue&type=script&lang=ts&"
import style0 from "./AnomalyDetection.vue?vue&type=style&index=0&id=61daf12e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports